import { format as dateFormat } from "date-fns"

export class DateHelper {

  static convertToDate(input: string | Date | number): Date {
    return new Date(Date.parse(input.toString()));
  }

  static convertToDateOnly(input: string | Date | number): Date {
    let result = new Date(Date.parse(input.toString()));
    result.setHours(result.getHours() + 12);
    return result;
  }

  static addDays(date: Date, days: number) {
    date.setDate(date.getDate() + days);
    return date;
  }

  static prettyDate(date: Date) {
    if (date === undefined || date === null) return "";
    return this.formatDateTime(date, "MMM d, yyyy");
  }

  static prettyDateTime(date: Date) {
    if (date === undefined || date === null) return "";
    return this.formatDateTime(date, "MMM d, yyyy h:mm a");
  }

  static formatHtml5Date(date: Date): string {
    let result = "";
    if (date !== undefined && date !== null) {
      try {
        result = new Date(date).toISOString().split("T")[0];
      } catch { }
    }
    return result;
  }

  static formatHtml5DateTime(date: Date): string {
    if (date === undefined || date === null) return "";
    else {
      return this.formatDateTime(date, "yyyy-MM-dd") + "T" + this.formatDateTime(date, "HH:mm");
    }
  }

  static getDisplayDuration(d: Date): string {
    let seconds = Math.round((new Date().getTime() - d.getTime()) / 1000);
    if (seconds > 86400) {
      let days = Math.floor(seconds / 86400);
      return (days === 1) ? "1d" : days.toString() + "d";
    }
    else if (seconds > 3600) {
      let hours = Math.floor(seconds / 3600);
      return (hours === 1) ? "1h" : hours.toString() + "h";
    }
    else if (seconds > 60) {
      let minutes = Math.floor(seconds / 60);
      return (minutes === 1) ? "1m" : minutes.toString() + "m";
    }
    else return (seconds === 1) ? "1s" : Math.floor(seconds).toString() + "s";
  }

  static getShortDate(d: Date): string {
    return (d.getMonth() + 1).toString() + "/" + (d.getDate() + 1).toString() + "/" + d.getFullYear().toString();
  }

  public static formatDateTime(date: Date, format: string) {
    try {
      return dateFormat(date, format);
    } catch (ex) {
      console.warn(ex);
      return "";
    }
  }
}